module.exports = __webpack_public_path__ + "img/9788990274632.9817e1fe.jpg";